export default {
  required: value => (!!value && /^(?!\s*$).+/.test(value)) || 'field_required',
  email: value => /.+@.+\..+/.test(value) || 'email_format_error',
  mobile: v => {
    let telCheck = new RegExp(/^[0][9]\d{8}$/);
    if (isNaN(v) || !telCheck.test(v)) {
      return 'mobile_format_error';
    }
    return true;
  },
  passwordLengthValidation: value => {
    return value.length >= 8 || 'password_short_error';
  },
  password: value => {
    // let regex = new RegExp(
    //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!@#$%^&*()_\-+={}[\]|\\:;\"\'<,>.?\/])[A-Za-z\d~`!@#$%^&*()_\-+={}[\]|\\:;\"\'<,>.?\/]{8,}$/
    // );
    let regex = new RegExp(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d~`!@#$%^&*()_\-+={}[\]|\\:;\"\'<,>.?\/]{8,}$/
    );
    return regex.test(value) || 'password_format_error'
  },
  idNumberValid: value => {
    var reg = /^[A-Z]{1}[1-2]{1}[0-9]{8}$/; //身份證的正規表示式;
    // 小寫可過
    if(!value || value === '' )  return 'id_number_validation'; 
    if (reg.test(value.toUpperCase())) {
      var s = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'; //把 A 取代成 10,把 B 取代成 11...的作法
      var ct = [
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '34',
        '18',
        '19',
        '20',
        '21',
        '22',
        '35',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '32',
        '30',
        '31',
        '33',
      ];

      var i = s.indexOf(value.toUpperCase().charAt(0));
      var tempuserid = ct[i] + value.substr(1, 9); //若此身份證號若是A123456789=>10123456789
      var num = tempuserid.charAt(0) * 1;

      for (i = 1; i <= 9; i++) {
        num = num + tempuserid.charAt(i) * (10 - i);
      }

      num += tempuserid.charAt(10) * 1;
      // console.log(`return: ${num % 10 === 0 || 'id_number_validation'}`)
      return num % 10 === 0 || 'id_number_validation';
    } 
    // console.log(`return: id_number_validation`)
    return 'id_number_validation';
  }
};
